import { call, put } from 'redux-saga/effects'
import api from '../../utils/api'
import actions from './actions'

const queryPasses = siteCode => call(api.getOutstandingPasses, siteCode)

function* fetchPasses(action) {
  yield put({ type: actions.fetchPending, siteCode: action.siteCode })
  let passes
  try {
    passes = yield queryPasses(action.siteCode)
  } finally {
    yield put({ type: actions.setPasses, payload: { passes, siteCode: action.siteCode }})
  }
}

export default fetchPasses



// WEBPACK FOOTER //
// ./src/store/passes/saga.js